// Turn timer and personal time bank (suunnitelma.md sections 18, 19, 37). Pure functions:
// the server evaluates them with its own clock; the UI only uses them for display.

export interface TurnClockInput {
  /** Server time (ms) when the turn started. */
  turnStartedAt: number;
  /** Normal turn time limit (ms). */
  turnTimeMs: number;
  /** The player's time bank balance at the start of the turn (ms). */
  timeBankMs: number;
  /** Current server time (ms). */
  now: number;
}

export interface TurnClockState {
  /** turn = normal turn time running; bank = time bank running; expired = player has lost on time. */
  phase: 'turn' | 'bank' | 'expired';
  turnRemainingMs: number;
  bankRemainingMs: number;
  /** Server time (ms) when the player runs out of time. */
  deadline: number;
}

export function turnClock({ turnStartedAt, turnTimeMs, timeBankMs, now }: TurnClockInput): TurnClockState {
  const normalEnd = turnStartedAt + turnTimeMs;
  const deadline = normalEnd + timeBankMs;
  if (now < normalEnd) {
    return { phase: 'turn', turnRemainingMs: normalEnd - now, bankRemainingMs: timeBankMs, deadline };
  }
  if (now < deadline) {
    return { phase: 'bank', turnRemainingMs: 0, bankRemainingMs: deadline - now, deadline };
  }
  return { phase: 'expired', turnRemainingMs: 0, bankRemainingMs: 0, deadline };
}

/** Time bank balance left after the player acts at `now` (consumption stops at the move). */
export function bankAfterMove(input: TurnClockInput): number {
  return turnClock(input).bankRemainingMs;
}
